export default "__VITE_ASSET__3f2f81e0__"